module.exports = {
  TheExpiredAndNoCreated: 'Hợp đồng của đơn vị ủy thác đã hết hạn, không thể tạo nghiệp vụ mới!',
  NotTheCorrectOperationStatus: 'Không ở trạng thái thao tác chính thức.',
  NoDataSelected: 'Chưa chọn dữ liệu',
  AllAreInNonStatus: 'Tất cả bản ghi dữ liệu được chọn đều không ở trạng thái [thao tác chính thức]',
  ThisSelfConsolidationBuyerConsolidation: 'Loại ghép chuyến này không phải tự ghép container, buyer consol hay ủy thác ghép container',
  AttachmentContentTooLarge: 'Nội dung tệp đính kèm quá lớn',
  AreWantToWithdrawBill: 'Xác nhận thu hồi chuyến hàng này?',
  SplitOrder: 'Tách đơn',
  MergeOrder: 'Gộp đơn',
  SRIFailedPleaseContactTroubleshooting: 'Đẩy đơn ủy thác SIRIUS thất bại, vui lòng liên hệ nhân viên kiểm tra:',
  OperationSuccessful: 'Thao tác thành công',
  ContainerType: 'Loại container',
  LockedPrintedPleaseContactUnlocking: 'Đã bị khóa, không thể in, vui lòng liên hệ quản lý mở khóa!',
  FullContainerProfitPrint: 'In lợi nhuận FCL',
  LCLProfitPrint: 'In lợi nhuận LCL',
  NoSubTicketSelected: 'Chưa chọn phiếu nhỏ',
  CustomersSuchAsPOEtc: 'Chỉ số riêng của khách hàng cho lô hàng, như PO NBR, ITEM NBR...',
  OriginalBillOfLading: 'Bản gốc',
  TelexRelease: 'Surrender (điện báo giao hàng)',
  NoLoadingInformationSelected: 'Chưa chọn thông tin đóng hàng',
  PleaseASubTicketRecord: 'Vui lòng chọn bản ghi phiếu nhỏ',
  PleaseSelectAContainer: 'Vui lòng chọn một container',
  BillOfLadingInformationTracking: 'Theo dõi thông tin vận đơn',
  ReleaseNumber: 'Số vận đơn phát hành:',
  Unknown: 'Không rõ',
  ViewExceptions: 'Xem bất thường',
  PleaseSelectDesignatedData: 'Vui lòng chọn dữ liệu chỉ định',
  LicenseOfLadingNumberEmpty: 'Biển số xe và số vận đơn không được để trống',
  NoRelevantInformationAvailable: 'Chưa có thông tin liên quan',
  DoToDeleteTheTicket: 'Xác nhận xóa phiếu nhỏ?',
  AuditSuccessful: 'Duyệt thành công',
  Allocation: 'Phân luồng',
  ChangeOrders: 'Đổi vận đơn',
  ImportManifest: 'Manifest nhập khẩu'
}
